import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=0e23304e&scoped=true"
import script from "./teamInfo.vue?vue&type=script&lang=js"
export * from "./teamInfo.vue?vue&type=script&lang=js"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=0e23304e&prod&scoped=true&lang=scss"
import style1 from "./teamInfo.vue?vue&type=style&index=1&id=0e23304e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23304e",
  null
  
)

export default component.exports